import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { useFilters } from "../../contexts/FilterContext";

export const SearchBar = () => {
  const { filters, updateFilter } = useFilters();

  return (
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
      <Input
        type="text"
        placeholder="Search listings..."
        value={filters.searchTerm}
        onChange={(e) => updateFilter("searchTerm", e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-igbanwo-mint/20 focus:border-igbanwo-mint"
      />
    </div>
  );
};
